// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-PointMain-module--cls1--1U42r","cls2":"styles-PointMain-module--cls2--3dZ-o styles-PointMain-module--cls1--1U42r"};